<template>
  <div class="layout-container"
   :style="rootStyle" v-if="isReady">
    <top></top>
    <router-view :key="$route.fullPath"></router-view>
    <bottom></bottom>
  </div>
</template>

<script>
  import top from '@/layout/top'
  import bottom from '@/layout/bottom'
  export default {
    name: 'layout',
    components: {
      top,
      bottom
    },
    data() {
      return {
        isReady: 0,
        rootStyle: {},
        navList: [],
      }
    },
    created() {
      this.getRoot()
    },
    methods: {
      getRoot(){
        localStorage.setItem('websiteId', this.$route.query.website_id || '')
        const globalObj = {
          breadcrumb: { path: '/',name: '首页', query: {website_id: localStorage.getItem('websiteId')}},
        }
        this.$store.state.globalObj = globalObj
        this.rootStyle = {
          minHeight: '100vh',
          '--textColor': '#333333',
          '--height': '50vh',
          '--width': '1250px',
          '--pcwidth': '1250px',
        }
        this.checkPlatform()
        this.$api.get('/api/web_list_temp/get_seo',{
          params:{
            website_id: localStorage.getItem('websiteId')
          },
        }).then(res => {
          const data = res.data
          if(data.seoData) {
            data.seoData.title ? document.title = data.seoData.title : ''
            document.getElementsByName('keywords')[0].content = data.seoData.keywords || ''
            document.getElementsByName('description')[0].content = data.seoData.description || ''
          }
          if(data.textSyle){
            this.rootStyle = {...this.rootStyle,...data.textSyle}
          }
          // console.log(this.rootStyle);
          this.isReady = 1
        })
      },
      checkPlatform() {
        if ((navigator.userAgent.match(/(iPhone|iPod|Android|ios|iOS|iPad|Backerry|WebOS|Symbian|Windows Phone|Phone)/i))) {
          console.log('mobile访问')
          this.$store.state.globalObj.pc = 0
          document.documentElement.style.fontSize = `${window.innerWidth / (375 * 2)}px`
          this.rootStyle['--width'] = window.innerWidth + 'px'
          this.$store.state.globalObj.px2rem = 'rem'
        } else {
          console.log('PC访问')
          // document.documentElement.style.fontSize = `${window.innerWidth / (375 * 4.1)}px`
          this.$store.state.globalObj.px2rem = 'px'
          this.$store.state.globalObj.pc = 1
        }
      },
    }
  }
</script>

<style lang="less" scoped>
  .layout-container{
    min-width: var(--width);
  }
  /deep/ .pagination{
    margin-top: 10px;
    padding: 20px 0;
    width: 100%;
    text-align: right;
  }
  /deep/ .mobile-pagination{
    button, span:not([class*=suffix]),.el-pager li{
      height: 34rem;
      line-height: 34rem;
      font-size: 20rem;
      padding: 0 4rem;
      margin: 0 5rem !important;
      min-width: 36rem !important;
    }
    span:not([class*=suffix]){
      padding: 0;
    }
    .btn-next, .btn-prev{
      min-width: 34rem;
      & .el-icon{
        font-size: 18rem;
      }
    }
    // .btn-next .el-icon, .btn-prev .el-icon{
    //   font-size: 18rem;
    // }
  }
</style>



// WEBPACK FOOTER //
// src/layout/index.vue